import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import { Cart } from 'icons';
import type { TSizeType } from 'interfaces';

export const SIZE_STYLES: Record<
  TSizeType,
  Record<'wrapper' | 'icon' | 'count', FlattenSimpleInterpolation>
> = {
  huge: {
    wrapper: css`
      padding: 12px 12px;
    `,
    icon: css`
      font-size: var(--ft-icon-size-lg);
    `,
    count: css`
      font-size: var(--ft-font-size-300);
      line-height: var(--ft-line-height-100);
      padding: 2px 6px;
      border-radius: 12px;
    `
  },
  large: {
    wrapper: css`
      padding: 8px 12px;
    `,
    icon: css`
      font-size: var(--ft-icon-size-md);
    `,
    count: css`
      font-size: var(--ft-font-size-300);
      line-height: var(--ft-line-height-100);
      padding: 0 5px;
      border-radius: 12px;
    `
  },
  medium: {
    wrapper: css`
      padding: 8px 12px;
    `,
    icon: css`
      font-size: var(--ft-icon-size-sm);
    `,
    count: css`
      font-size: var(--ft-font-size-0);
      line-height: var(--ft-line-height-0);
      padding: 4px 5px;
      border-radius: 10px;
    `
  },
  small: {
    wrapper: css`
      padding: 6px 10px;
    `,
    icon: css`
      font-size: var(--ft-icon-size-xs);
    `,
    count: css`
      font-size: var(--ft-font-size-0);
      line-height: var(--ft-line-height-0);
      padding: 4px 5px;
      border-radius: 10px;
    `
  }
};

export const CartIcon = styled(Cart)`
  margin-left: -3px;
`;

export const CartCountChip = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--v3-primary-color);
  color: var(--v3-text-color-inverse);
  font-weight: 700;
  border: 1px solid var(--v3-black-0);
  margin-left: -11px;
  margin-top: -3px;
`;

export const CartWrapper = styled.div<{ $size: TSizeType }>`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: fit-content;
  height: fit-content;
  border-radius: 16px;
  cursor: pointer;

  &:hover {
    background: var(--v3-black-1);
  }

  ${({ $size }) => SIZE_STYLES[$size].wrapper}

  ${CartIcon} {
    ${({ $size }) => SIZE_STYLES[$size].icon}
  }

  ${CartCountChip} {
    ${({ $size }) => SIZE_STYLES[$size].count}
  }
`;
